/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Payment_Method_UnchangedInputs */

const vi_error_payment_method_unchanged = /** @type {(inputs: Error_Payment_Method_UnchangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoản thu đã đúng hình thức này rồi. Tải lại trang để xem hình thức mới nhất.`)
};

/**

* @param {Error_Payment_Method_UnchangedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_payment_method_unchanged = /** @type {((inputs?: Error_Payment_Method_UnchangedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Payment_Method_UnchangedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_payment_method_unchanged(inputs)
});